import { FormLabel } from '@chakra-ui/react';
import React from 'react';

const AppLabel = ({ fieldName, customStyles }) => {
  return <FormLabel {...customStyles}>{fieldName}</FormLabel>;
};

export default AppLabel;
